import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center justify-end gap-4 mini" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]

import Immobilie from '@/models/immobilie.model';
import { ImmobilieStatus } from '@/models/immobilie/interfaces/IImmobilie';
import { IonIcon } from '@ionic/vue';
import {
  alertCircleOutline, archiveOutline, arrowDownCircle, arrowDownCircleOutline, checkmarkCircleOutline,
  checkmarkDoneCircleOutline, ellipseOutline, locationOutline, playCircleOutline, shareSocialOutline, timeOutline
} from "ionicons/icons";
import { computed, PropType } from 'vue';
import ProfileIcon from '../Base/ProfileIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyActionButtons',
  props: {
    property: {
        type: Object as PropType<Immobilie>,
        required: true
    },
    isLocateButtonEnabled: {
        type: Boolean,
        default: true
    },
    isPersonButtonEnabled: {
        type: Boolean,
        default: true
    },
    isStatusButtonEnabled: {
        type: Boolean,
        default: true
    },
    isShareButtonEnabled: {
        type: Boolean,
        default: true
    },
    isDownloadButtonEnabled: {
        type: Boolean,
        default: false
    },
    propertyState: {
        type: String,
        default: "unknown"
    }
},
  emits: ['locate', 'change-status', 'change-person', 'share', 'download'],
  setup(__props) {

const props = __props;





const statusIconState = computed(() => {
    switch (props.property.status) {
        case ImmobilieStatus.ANGELEGT: return ellipseOutline;
        case ImmobilieStatus.GEPLANT: return timeOutline;
        case ImmobilieStatus.IN_DURCHFUEHRUNG: return playCircleOutline;
        case ImmobilieStatus.ABGESCHLOSSEN: return checkmarkCircleOutline;
        case ImmobilieStatus.FREIGEGEBEN: return checkmarkDoneCircleOutline;
        case ImmobilieStatus.ARCHIVIERT: return archiveOutline;
        default: return alertCircleOutline;
    }
});

const downloadIconState = computed(() => {
    if (props.propertyState === 'OfflineAvailable') {
        return arrowDownCircle;
    } else {
        return arrowDownCircleOutline;
    }
});

const user = computed(() => {
    if(props?.property?.verwalters && props.property.verwalters.length > 0) {
      return props.property.verwalters[0];
    } else {
      return null;
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLocateButtonEnabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex cursor-pointer",
          title: _ctx.$t('immobilie.redirectToMap'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('locate')), ["stop"]))
        }, [
          _createVNode(_unref(IonIcon), {
            size: "large",
            icon: _unref(locationOutline)
          }, null, 8, ["icon"])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.isStatusButtonEnabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex cursor-pointer",
          title: _ctx.$t('immobilie.updateStatus'),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('change-status')), ["stop"]))
        }, [
          _createVNode(_unref(IonIcon), {
            size: "large",
            icon: statusIconState.value
          }, null, 8, ["icon"])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.isPersonButtonEnabled)
      ? (_openBlock(), _createBlock(ProfileIcon, {
          key: 2,
          user: user.value,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change-person')))
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    (__props.isShareButtonEnabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "flex cursor-pointer",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('share')), ["stop"]))
        }, [
          _createVNode(_unref(IonIcon), {
            size: "large",
            icon: _unref(shareSocialOutline)
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    (__props.isDownloadButtonEnabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          title: _ctx.$t('downloadSurveyButton.download'),
          class: "flex cursor-pointer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('download')))
        }, [
          _createVNode(_unref(IonIcon), {
            size: "large",
            icon: downloadIconState.value
          }, null, 8, ["icon"])
        ], 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})